import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { notBecause, painPoints, planningQuestions, scratchHabits } from '../data/painPoints';
const reveal = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }
} as const;
export function PainPoints() {
  return <section className="py-24 px-4 bg-mist" data-id="element-151" data-mp="1xx851xfk5z8e">
      <div className="max-w-4xl mx-auto" data-id="element-152" data-mp="1xwg7wi6bbtg0">
        <motion.div {...reveal} className="text-center mb-12" data-id="element-153" data-mp="21z38b7h1umot">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy uppercase" data-id="element-154" data-mp="21x8ibeqx84dv">
            Still Spending Hours Planning Every Scuba Lesson?
          </h2>
          <div className="text-lg text-ink leading-relaxed bg-white p-6 md:p-8 rounded-2xl border border-slate-200 text-left space-y-4" data-id="element-155" data-mp="1szg46dwxr2s2">
            <p data-id="element-156" data-mp="3ibrzs5bi8gem">
              Another student.
              <br data-id="element-157" data-mp="3nbmpi5jjmzy3" />
              Another session.
              <br data-id="element-158" data-mp="3nablc4m6rq6g" />
              Another skill to teach.
              <br data-id="element-159" data-mp="1yzdogqcqmjon" />
              Another evening deciding:
            </p>
            <ul className="space-y-2 pl-1" data-id="element-160" data-mp="1u23o4fnt8nm1">
              {planningQuestions.map(question => <li key={question} className="flex items-start gap-3 text-navy font-semibold" data-id="element-161" data-mp="27t8ip3cbmppi">
                  <span className="w-1.5 h-1.5 rounded-full bg-cta shrink-0 mt-3" aria-hidden="true" data-id="element-162" data-mp="23qvggows99xh" />
                  <span data-id="element-163" data-mp="1g112g40q9fbn">{question}</span>
                </li>)}
            </ul>
            <div data-id="element-164" data-mp="1b39a58w67r6x">
              {notBecause.map(line => <p key={line} className="text-navy font-semibold" data-id="element-165" data-mp="1b4spmxa05y7n">
                  {line}
                </p>)}
            </div>
            <p data-id="element-166" data-mp="1k34pzr0o8ada">
              Because knowing scuba diving and having a{' '}
              <span className="text-navy font-semibold" data-id="element-167" data-mp="30he5rwqukqsi">complete teaching system</span> are two very
              different things.
            </p>
            <p className="text-navy font-semibold" data-id="element-168" data-mp="2vi1hr8o8pdoc">
              Without a system, every student can become another session you need to build from
              scratch.
            </p>
            <p data-id="element-169" data-mp="1y2x1v0hnwfzm">{scratchHabits.join(' ')}</p>
            <p data-id="element-170" data-mp="1y62tonhodvz1">And the time you should spend teaching becomes planning time.</p>
          </div>
        </motion.div>

        <motion.div {...reveal} data-id="element-171" data-mp="274o7648aiksy">
          <h3 className="text-xl font-bold text-navy mb-8 text-center uppercase tracking-wide" data-id="element-172" data-mp="273v8lqjhj1lw">
            The Real Cost of Planning Everything From Scratch
          </h3>
          <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm shadow-navy/5" data-id="element-173" data-mp="1efr06x9j4afi">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 px-5 py-4 text-ink text-sm leading-relaxed border-t first:border-t-0 border-slate-200" data-id="element-174" data-mp="1jd91q2l7vndh" data-mpi={index}>
                <X size={16} className="text-red-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-175" data-mp="j6ncei122f43" />
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-slate-200" data-id="element-176" data-mp="e9wxhy0zlpk9">
            <p className="text-2xl font-serif font-bold text-navy" data-id="element-177" data-mp="a67ave3vhi1v">
              Your scuba experience is already there.
            </p>
            <p className="text-xl mt-4 text-ink" data-id="element-178" data-mp="gxkq3sla9ge">
              What you need is a <span className="text-cta font-semibold" data-id="element-179" data-mp="ekxbb42b6vy">system</span> that helps
              you use that experience faster, more visually and more professionally.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}